import { render, staticRenderFns } from "./AppMediaPopup.vue?vue&type=template&id=4b5cef6c&scoped=true"
import script from "./AppMediaPopup.vue?vue&type=script&lang=ts"
export * from "./AppMediaPopup.vue?vue&type=script&lang=ts"
import style0 from "./AppMediaPopup.vue?vue&type=style&index=0&id=4b5cef6c&prod&lang=scss&scoped=true"
import style1 from "./AppMediaPopup.vue?vue&type=style&index=1&id=4b5cef6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5cef6c",
  null
  
)

export default component.exports